import xml from "csi/xml";
import { computed } from "mobx";
import { EnumData } from "./reflectionTypes";
import ReflectionEnumValue from "./ReflectionEnumValue";

class ReflectionEnum {
	readonly _data: EnumData;

	@computed get activeValues(): ReflectionEnumValue[] {
		return this.values.filter((enumValue) => enumValue.active);
	}

	get name(): string {
		return this._data[0];
	}

	get internal(): boolean {
		return !!this._data[2];
	}

	get custom(): boolean {
		return !!this._data[3];
	}

	get containsClassNames(): boolean {
		return !!this._data[4];
	}

	get dependsOn(): string {
		return this._data[5];
	}

	get dependsOnValues(): Array<Array<string>> {
		return this._data[6];
	}

	@computed get values(): ReflectionEnumValue[] {
		const { dependsOnValues, _data } = this;
		return _data[1]?.map((values, index) => new ReflectionEnumValue(values, dependsOnValues?.[index])) ?? [];
	}

	/**
	 * @deprecated
	 */
	getId(): string {
		return this.name;
	}

	getValue(text: string): string {
		return xml.enumCreate(this.name, text);
	}

	/**
	 * Return the index of the enum value
	 */
	getValueIndex(value: string): number {
		const valueName = xml.enumGetText(value);
		return this.values.findIndex((enumValue) => enumValue.$Name == valueName);
	}

	/**
	 * Return all possible values in <EnumList-Name>:<ReflectionEnumValue-Name> format
	 */
	getEnums(): string[] {
		const { activeValues, name } = this;
		return activeValues.map((enumValue) => xml.enumCreate(name, enumValue.name));
	}

	/**
	 * Return true if given value is active
	 */
	hasActiveValue(value: string): boolean {
		return this.activeValues.some((enumValue) => enumValue.$Name === value);
	}

	constructor(data: EnumData) {
		this._data = data;
	}
}

export = ReflectionEnum;